import React from 'react'

export default function Footer() {
  return (
    <footer>  
        <span>RepoViewer 2024 &copy;</span>
    </footer>
  )
}
